import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom'

export function ErrorPage() {
  const error = useRouteError()

  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : 'An unexpected error occurred'

  return (
    <div className="min-h-screen bg-cosmic-void flex flex-col items-center justify-center text-center p-6">
      <span className="text-5xl mb-4">💫</span>
      <h1 className="text-star-white text-2xl font-semibold mb-2">The cosmos is misaligned</h1>
      <p className="text-star-muted text-sm max-w-sm mb-6 leading-relaxed">{message}</p>
      <Link
        to="/"
        className="px-4 py-2 rounded-lg bg-violet text-star-white text-sm font-medium
                   hover:bg-violet-mid transition-colors"
      >
        Return to Dashboard
      </Link>
    </div>
  )
}
